module.exports = __webpack_public_path__ + "img/vk.258a9e69.svg";